import React from 'react'

const ServiceCarouselItemIndicator = ( { onClick, activeIndex, index  } ) => {
    return (
        <span className = {`${index === activeIndex ? "Service-Page-Carousel-Indicators active-indicator" :  "Service-Page-Carousel-Indicators"}`}  onClick = {onClick}></span>
    )
}

export default ServiceCarouselItemIndicator